module.exports = __webpack_public_path__ + "static/media/bg-send-love-back-alt.5176572e.svg";